import CartActions from './CartActions';
import StoreModal from './StoreModal';
import GlobalStoreHelper from './GlobalStoreHelper';
import CollectionPage from './CollectionPage';
import ModalHelper from './ModalHelper';

class StorePickup {
    /**
     * Technical implementation of the class
     * @param  {object} async_param used for determining when async init has completed
     * @return {void}
     */
    constructor(async_param) {
        if (typeof async_param === 'undefined') {
            throw new Error('Cannot be called directly');
        }

        this.storeModal = StoreModal;
        this.cartActions = CartActions;
        this.collectionPage = new CollectionPage;
        this.modalHelper = new ModalHelper;
        this.settings = GlobalStoreHelper.settings();

        if (GlobalStoreHelper.ifStoreSelected() && document.getElementById('snize_results')) {
            const drawn = document.querySelectorAll('.snize-item .stock-text');
            if (drawn.length === 0) {
                this.collectionPage.outputStockInfo();
            }
        }

        this.initStoreSelector();
    }

    /**
     * Since the logic depends on async init calls, we build it and call the class
     * with received response information
     * @return {object} The class itself with async responses
     */
    static async build() {
        // Fetch configuaration items
        const configItems = await GlobalStoreHelper.getConfigItems();
        const settings = GlobalStoreHelper.settings();

        // Fetch default store based on location or existing localStorage
        if(configItems.defaultStoreSelection === 'true' || !configItems.defaultStoreSelection){
            await GlobalStoreHelper.fetchAndInitDefaultStore();
        }else if(!GlobalStoreHelper.getItem('locationId') || !GlobalStoreHelper.getItem('firstLoadKey')){
            localStorage.removeItem(settings.locationId);
            StoreModal.toggleStoreSelector();
        }

        // Async calls over, init class
        window.storePickup = new StorePickup({ configItems: configItems });

        const body = document.getElementsByTagName('body')[0];
        if (body && body.classList.contains('template-cart')) {
            // In case store delivery is disabled, abort
            const parentMobDom = document.querySelector('.store-selector-mobile');
            if (!parentMobDom) return;
            CartActions.initCartDeliverySelection();
        }
    }

    /**
     * Perform full module initialisation for each of the store pages and navigations
     * @return {void}
     */
    initStoreSelector() {
        this.injectGoogleMaps();
        this.eventForHeaderDropdownClosing();
        GlobalStoreHelper.updateStoreNames();
    }

    /**
     * Opens/Closes header store selector and updates store information if it is present
     * @param {boolean} mobView Determine whether apply logic for mobile menu
     * @returns void
     */
    toggleStoreDropdown(mobView = false) {
        const parentDom = document.querySelector(mobView ? '.store-selector-mobile' : '.header-store-selector');
        const storeDropdown = parentDom.querySelector('#store-info');
        const storeAddress = parentDom.querySelector('#store-info .address');
        const storeExtraInfo = parentDom.querySelector('#store-info .store-information');
        const headerMobileBtn = document.querySelector('.store-selector-mobile #store-selector-trigger');
        const headerBtn = document.querySelector('#store-selector-trigger');

        if (storeDropdown.classList.contains('shown')) {
            headerBtn.classList.remove('open');
            storeDropdown.classList.remove('shown');
            storeDropdown.classList.remove('open');
            if (mobView) {
                headerMobileBtn.classList.remove('open');
            }
            return;
        } else {
            headerBtn.classList.add('open');
            storeDropdown.classList.add('shown');
            storeDropdown.classList.add('open');
            if (mobView) {
                headerMobileBtn.classList.add('open');
            }
        }

        const locations = GlobalStoreHelper.getItem('locations') || {};
        const locationId = GlobalStoreHelper.getItem('locationId')
        const store = locations[locationId];
        storeAddress.innerHTML =  GlobalStoreHelper.combineAddress(store)

        if (store && store.url) {
          storeExtraInfo.classList.add('show');
          document.querySelector('#store-info-trigger').href = store.url;
        } else {
            storeExtraInfo.classList.remove('show');
        }
    };

    /**
     * Add google maps library to perform geocoding requests
     */
    async injectGoogleMaps() {
        const config = await GlobalStoreHelper.getConfigItems();
        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://maps.googleapis.com/maps/api/js?v=beta&key=${config.geocodingApiKey}`;
        head.appendChild(script);
    }

    /**
     * Upon clicking outside the dropdown of store infomation, close it
     */
    eventForHeaderDropdownClosing() {
        document.addEventListener('click', (event) => {
            const parentMobDom = document.querySelector('.store-selector-mobile');
            const parentDom = document.querySelector('.header-store-selector');

            // In case store delivery is disabled, abort
            if (!parentMobDom) return;

            const partOfMob = parentMobDom.contains(event.target);
            const partOf = parentDom.contains(event.target);
            if (partOf || partOfMob) return;

            const open = parentDom.querySelector('#store-info').classList.contains('open');
            const openMob = parentMobDom.querySelector('#store-selector-trigger').classList.contains('open');
            if (!open && !openMob) return;

            let mobChild = null;
            let child = null;

            if (parentMobDom && event.target.className) {
                mobChild = parentMobDom.querySelector(event.target.className);
            }
            if (parentDom && event.target.className) {
                child = parentDom.querySelector(event.target.className);
            }

            if (!mobChild && !child) {
                this.toggleStoreDropdown(openMob);
            }
        });
    }

    ifStoreSelected(){
        return GlobalStoreHelper.getItem('locationId') && GlobalStoreHelper.getItem('firstLoadKey') ? true : false;
    }
}

/**
 * First event is fired before storePickup is ready, but storePickup calls the
 * same  method when it is loaded. For next re-renders this hook allows to show
 * updated stock for filtered items.
 *
 * Searchanise Plugin uses jQuery event firing, which are not being catched with native JS
 * https://bugs.jquery.com/ticket/11047#comment:1
 */
if (typeof $ !== 'undefined') {
    $(document).on("Searchanise.ResultsUpdated", function (event, results) {
        if (typeof storePickup !== 'undefined') {
            storePickup.ifStoreSelected() && storePickup.collectionPage.outputStockInfo();
        }
    });
}

StorePickup.build();
